import { render, staticRenderFns } from "./BaseSimuladorIndicadorModal.vue?vue&type=template&id=6af75f7a&scoped=true"
import script from "./BaseSimuladorIndicadorModal.vue?vue&type=script&lang=js"
export * from "./BaseSimuladorIndicadorModal.vue?vue&type=script&lang=js"
import style0 from "./BaseSimuladorIndicadorModal.vue?vue&type=style&index=0&id=6af75f7a&prod&lang=css"
import style1 from "./BaseSimuladorIndicadorModal.vue?vue&type=style&index=1&id=6af75f7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af75f7a",
  null
  
)

export default component.exports